import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import Contact from '../components/Contact';

function ContactPage() {
  return (
    <>
      <PageHero
        label="Nexus Concordat"
        title="Get In Touch"
      />
      <BackButton />
      <Contact />
    </>
  );
}

export default ContactPage;
